const SHEET_NAME = "Index";

const HEADER_FILL = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FFB9D1EA" },
};

const THIN_BLACK = {
  top: { style: "thin", color: { argb: "FF000000" } },
  left: { style: "thin", color: { argb: "FF000000" } },
  bottom: { style: "thin", color: { argb: "FF000000" } },
  right: { style: "thin", color: { argb: "FF000000" } },
};

const BODY_FONT = { name: "Calibri", size: 11 };
const LINK_FONT = {
  name: "Calibri",
  size: 11,
  color: { argb: "FF0563C1" },
  underline: true,
};

const COL_START = 4; // D
const COL_END = 10; // J

const beforePoints = [
  "1. The version of Microsoft Excel in your system should be Microsoft Office Excel 2007 and above.",
  "2. The system should have a file compression software to unzip excel utility file.",
  "3. Make sure that you have downloaded the latest Excel Utility.",
  "4. Make sure that you have downloaded the Chrome Browser to view report generated from Excel utility.",
  "5. Please enable the Macros (if disabled) as per instructions given in manual, so that all the functionalities of Excel Utility works.",
];

const indexSheets = [
  "General Disclosures",
  "Stock exchange",
  "Name of assurance Provider",
  "Type of assurance obtained",
  "Details of business activities",
  "Products services sold",
  "Holding,subsidiary or associate",
  "Other stakeholder group",
  "Business conduct issues",
  "MGT and process disclosure",
  "PRINCIPLE 1",
  "Penalty or fine",
  "Settlement",
  "Compounding fee",
  "Imprisonment",
  "Punishment",
  "Appeal or revision case details",
  "Programmes for value chain",
  "PRINCIPLE 2",
  "Life cycle assessment",
  "Action taken",
  "Recycled or reused input",
  "Details of other waste",
  "Reclaimed",
  "PRINCIPLE 3",
  "Other retirement benefits",
  "PRINCIPLE 4",
  "Stakeholder group",
  "PRINCIPLE 5",
  "Other assessments",
  "Details of other value chain",
  "PRINCIPLE 6",
  "Energy consumed from renewable",
  "Energy consumed from NR",
  "Details of other air emissions",
  "Environment approval (clearance)",
  "Environmental impact",
  "Plant in area of water stress",
  "Initiative to improve resource",
  "PRINCIPLE 7",
  "Action taken on issue",
  "Public policy advocates",
  "PRINCIPLE 8",
  "Details of SIA",
  "Project for rehabilitation",
  "Action to mitigate negative SIA",
  "CSR in aspirational districts",
  "Details of the benefits from IP",
  "Details of corrective action IP",
  "Details of CSR Project",
  "PRINCIPLE 9",
];

const fillUpData = [
  "1. Cells with red fonts indicate mandatory fields.",
  "2. If mandatory field is left empty, then Utility will not allow you to proceed further for generating XML.",
  "3. You are not allowed to enter data in the Grey Cells.",
  "4. If fields are not applicable to your company then leave it blank. Do not insert Zero unless it is a mandatory field.",
  "5. Data provided must be in correct format, otherwise Utility will not allow you to proceed further for generating XML.",
  '6. Select data from "Dropdown list" wherever applicable.',
];

const stepsForFiling = [
  "I.  Fill up the data: Navigate to each field of every section in the sheet to provide applicable data in correct format. (Formats will get reflected while filling data.) \r\n- Use paste special command to paste data from other sheet.",
  'II. Validating Sheets:  Click on the "Validate" button to ensure that the sheet has been properly filled and also data has been furnished in proper format. If there are some errors on the sheet, excel utility will prompt you about the same.',
  'III. Validate All Sheets:  Click on the "Home" button. And then click on "Validate All Sheet" button to ensure that all sheets has been properly filled and validated successfully. If there are some errors on the sheet, excel utility will prompt you about the same and stop validation at the same time. After correction, once again follow the same procedure to validate all sheets. Excel Utility will not allow you to generate XBRL/XML until you rectify all errors.',
  "IV. Generate XML : Excel Utility will not allow you to generate XBRL/XML unless successful validation of all sheet is completed. Now click on \"Generate XML\" to generate XBRL/XML file. \r\n- Save the XBRL/XML file in your desired folder in local system.",
  'V. Generate Report : Excel Utility will allow you to generate Report. Now click on "Generate Report" to generate html report. \r\n- Save the HTML Report file in your desired folder in local system. \r\n- To view HTML Report open "Chrome Web Browser" .\r\n- To print report in PDF Format, Click on print button and save as PDF.',
];

const internalLink = (row, col = "D") => `#'${SHEET_NAME}'!${col}${row}`;
const sheetLink = (name) => `#'${name}'!A1`;

function borderCell(cell) {
  cell.border = THIN_BLACK;
}

function mergeAndStyle(ws, row, value, options = {}) {
  const {
    bold = false,
    fill = null,
    align = "left",
    font = BODY_FONT,
    hyperlink = null,
    rowHeight = null,
  } = options;

  ws.mergeCells(row, COL_START, row, COL_END);
  const cell = ws.getCell(row, COL_START);

  if (hyperlink) {
    cell.value = { text: value, hyperlink };
    cell.font = LINK_FONT;
  } else {
    cell.value = value;
    cell.font = bold ? { ...font, bold: true } : font;
  }

  if (fill) cell.fill = fill;
  borderCell(cell);
  cell.alignment = {
    horizontal: align,
    vertical: "middle",
    wrapText: true,
  };

  if (rowHeight) ws.getRow(row).height = rowHeight;
}

function addTocRow(ws, row, number, label, anchor) {
  const numCell = ws.getCell(row, COL_START);
  numCell.value = number;
  numCell.font = BODY_FONT;
  borderCell(numCell);
  numCell.alignment = { horizontal: "center", vertical: "middle" };

  ws.mergeCells(row, COL_START + 1, row, COL_END - 1);
  const labelCell = ws.getCell(row, COL_START + 1);
  labelCell.value = { text: label, hyperlink: anchor };
  labelCell.font = LINK_FONT;
  borderCell(labelCell);
  labelCell.alignment = { horizontal: "left", vertical: "middle", wrapText: true };
}

function addIndexSheetRow(ws, row, number, sheetName) {
  const numCell = ws.getCell(row, COL_START);
  numCell.value = number;
  numCell.font = BODY_FONT;
  borderCell(numCell);
  numCell.alignment = { horizontal: "center", vertical: "middle" };

  ws.mergeCells(row, COL_START + 1, row, COL_END - 1);
  const labelCell = ws.getCell(row, COL_START + 1);
  labelCell.value = sheetName;
  labelCell.font = BODY_FONT;
  borderCell(labelCell);
  labelCell.alignment = { horizontal: "left", vertical: "middle", wrapText: true };

  const linkCell = ws.getCell(row, COL_END);
  linkCell.value = { text: sheetName, hyperlink: sheetLink(sheetName) };
  linkCell.font = LINK_FONT;
  borderCell(linkCell);
  linkCell.alignment = { horizontal: "left", vertical: "middle" };
}

function addTextRows(ws, startRow, lines, rowHeight) {
  lines.forEach((text, idx) => {
    mergeAndStyle(ws, startRow + idx, text, { rowHeight });
  });
  return startRow + lines.length;
}

export function buildIndexSheet(workbook) {
  const OVERVIEW_HEADER_ROW = 14;
  const BEFORE_HEADER_ROW = 18;
  const INDEX_HEADER_ROW = 26;
  const INDEX_DATA_START = 27;
  const STEPS_HEADER_ROW = INDEX_DATA_START + indexSheets.length + 2;
  const STEPS_DATA_START = STEPS_HEADER_ROW + 1;
  const FILLUP_HEADER_ROW = STEPS_DATA_START + stepsForFiling.length + 2;
  const FILLUP_DATA_START = FILLUP_HEADER_ROW + 1;

  const tocRows = [
    { number: "1.", label: "Overview", anchor: internalLink(OVERVIEW_HEADER_ROW) },
    { number: "2.", label: "Before you begin", anchor: internalLink(BEFORE_HEADER_ROW) },
    { number: "3.", label: "Index", anchor: internalLink(INDEX_HEADER_ROW) },
    {
      number: "4.",
      label: "Steps for Filing Business Responsibility & Sustainability Reporting",
      anchor: internalLink(STEPS_HEADER_ROW),
    },
    { number: "5.", label: "Fill up the data in excel utility", anchor: internalLink(FILLUP_HEADER_ROW) },
  ];

  const ws = workbook.addWorksheet(SHEET_NAME, {
    views: [{ showGridLines: false }],
  });

  const widths = { A: 2.8, B: 2.8, C: 2.8, D: 7, E: 12, F: 12, G: 12, H: 12, I: 30, J: 30 };
  Object.entries(widths).forEach(([col, width]) => {
    ws.getColumn(col).width = width;
  });

  mergeAndStyle(ws, 6, "XBRL Excel Utility", {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  tocRows.forEach(({ number, label, anchor }, idx) => {
    addTocRow(ws, 7 + idx, number, label, anchor);
  });

  mergeAndStyle(ws, OVERVIEW_HEADER_ROW, "1. Overview", {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });
  mergeAndStyle(
    ws,
    OVERVIEW_HEADER_ROW + 1,
    "The excel utility can be used for creating the XBRL/XML file for efiling of Business Responsibility & Sustainability Report."
  );

  mergeAndStyle(ws, BEFORE_HEADER_ROW, "2. Before you begin", {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });
  addTextRows(ws, BEFORE_HEADER_ROW + 1, beforePoints);

  mergeAndStyle(ws, INDEX_HEADER_ROW, "3. Index", {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });
  indexSheets.forEach((sheetName, idx) => {
    addIndexSheetRow(ws, INDEX_DATA_START + idx, `${idx + 1}.`, sheetName);
  });

  mergeAndStyle(
    ws,
    STEPS_HEADER_ROW,
    "4. Steps for Filing Business Responsibility & Sustainability Reporting",
    { bold: true, fill: HEADER_FILL, align: "center" }
  );
  addTextRows(ws, STEPS_DATA_START, stepsForFiling, 60);

  mergeAndStyle(ws, FILLUP_HEADER_ROW, "5. Fill up the data in excel utility", {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });
  addTextRows(ws, FILLUP_DATA_START, fillUpData);

  return ws;
}
